import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contract-header',
  templateUrl: './contract-header.component.html',
  styleUrls: ['./contract-header.component.scss'],
})
export class ContractHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
